import { render } from "./Loading.vue?vue&type=template&id=27a5d5fc&scoped=true&ts=true"
import script from "./Loading.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loading.vue?vue&type=script&setup=true&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=27a5d5fc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a5d5fc"],['__file',"src/components/home/Loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27a5d5fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27a5d5fc', __exports__)) {
    console.log('reload')
    api.reload('27a5d5fc', __exports__)
  }
  
  module.hot.accept("./Loading.vue?vue&type=template&id=27a5d5fc&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('27a5d5fc', render)
  })

}


export default __exports__